import { OrganizationRequest } from '../request-models/organization-request.model';
import { omitUndefined } from './wire-value-utils';

/**
 * Builds the PUT /admin/organizations/:id body: only the hub's admin `ADMIN_ORGANIZATION_WRITABLE` fields that
 * are set (plus `oldOwnerRole` for an ownership transfer), so an update stays partial. `null` (clear) is kept.
 */
export function toOrganizationRequest(fields: OrganizationRequest): OrganizationRequest {
  return omitUndefined<OrganizationRequest>({
    name: fields.name,
    organizationType: fields.organizationType,
    ein: fields.ein,
    ssn: fields.ssn,
    streetAddressLine1: fields.streetAddressLine1,
    streetAddressLine2: fields.streetAddressLine2,
    city: fields.city,
    state: fields.state,
    zipCode: fields.zipCode,
    country: fields.country,
    email: fields.email,
    phone: fields.phone,
    billingResponsibility: fields.billingResponsibility,
    ownerProfileId: fields.ownerProfileId,
    chiefSupervisorProfileId: fields.chiefSupervisorProfileId,
    setupComplete: fields.setupComplete,
    oldOwnerRole: fields.oldOwnerRole,
  });
}
